module.exports = __webpack_public_path__ + "e45d5c706bca70320454dfa1dbc4d4ff.jpg";